import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectItem, TreeNode } from 'primeng/api';
import { LookupService } from '../services/lookups/lookup.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SearchFilter, SearchResult } from '../models/search.model';
import { SearchService } from '../services/search.service';
import { SearchresultsComponent } from './searchresults/searchresults.component';
import { NotifierService } from 'angular-notifier';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  searchForm: FormGroup;
  blockDatesOptionsForInternal: SelectItem[];
  blockDatesOptions: SelectItem[];
  countries: SelectItem[] = [];
  posts: SelectItem[] = [];
  reportCategories: TreeNode[];
  keyword: string;
  searchFilter: SearchFilter;
  selectedNodes: TreeNode[];
  searchResults: SearchResult[];
  loading:boolean=false;
  @ViewChild(SearchresultsComponent) searchResultsComponent:SearchresultsComponent;

  constructor(
    private lookupService: LookupService,
    private fb: FormBuilder,
    private searchService: SearchService,
    private notifier: NotifierService
  ) {}

  ngOnInit() {
   

    this.searchForm = this.fb.group({
      dateRange: [''],
      country: [''],
      post: [''],
      reporthighlights: [''],
      reportname: [''],
      fromDate: [''],
      toDate: [''],
      blockDate: [''],
      category: ['']
    });
    this.LoadAdvanceFilterOptions();
    
  }

  LoadAdvanceFilterOptions() {
    this.LoadBlockDateOptions();
    this.LoadAllCountries();
    this.LoadAllPosts();
    this.LoadReportCategoryHierarchy();
    this.searchForm.patchValue({country:[''],post:[''] });
    
  }
  search() {
    // if (this.keyword !== undefined && this.keyword !== '') {
    //console.log(this.searchForm.value);
    this.searchFilter = new SearchFilter();
    this.searchFilter.keyword = this.keyword;
    
    if (parseInt(this.searchForm.controls['dateRange'].value) === 0) {
      var currentDate = new Date();
      this.searchFilter.toDate = currentDate;
        if(parseInt(this.searchForm.controls['blockDate'].value) === 1)
        { this.searchFilter.fromDate = currentDate; }
        else
        {
      //console.log(currentDate.setDate(currentDate.getDate() - parseInt(this.searchForm.controls["blockDate"].value)).toLocaleString());
      //console.log(new Date(currentDate.toLocaleDateString()));
      var fromDate = new Date().setDate(currentDate.getDate() - parseInt(this.searchForm.controls['blockDate'].value));
      this.searchFilter.fromDate = new Date(fromDate);}
    } else if (parseInt(this.searchForm.controls['dateRange'].value) === 1) {
      this.searchFilter.fromDate = this.searchForm.controls['fromDate'].value;
      this.searchFilter.toDate = this.searchForm.controls['toDate'].value;
    }
    this.searchFilter.countryIds = this.searchForm.controls['country'].value;
    this.searchFilter.postNames = this.searchForm.controls['post'].value;
    if (this.selectedNodes !== undefined) this.TraverseChildNodes(this.selectedNodes, this.searchFilter.categoryIds);
    this.searchFilter.reportName = this.searchForm.controls['reportname'].value;
    this.searchFilter.reportHighlights = this.searchForm.controls['reporthighlights'].value;

    //console.log(this.searchForm);
    console.log("Search parameters" + JSON.stringify(this.searchFilter));
    this.searchService.getSearchResults$(this.searchFilter).subscribe(resp => {
     // console.log(resp);
      if (resp.ok) {
        this.searchResults = resp.body;
        // this.searchResults.sort((a, b) => {
        //   if (a.publishDate > b.publishDate) return -1;
        //   if (a.publishDate < b.publishDate) return 1;
        //   return 0;
        // });
        this.searchResultsComponent.resetPageIndex();
       // console.log(this.searchResults);
      }
    });
    // } else {
    //   this.notifier.notify('error', 'Keyword cannot be empty');
    // }
    //this.searchForm.reset();
  }

  private TraverseChildNodes(element: TreeNode[], categoryIds: number[]) {
    element.forEach(child => {
      if (child.children.length == 0) {
        if (categoryIds.indexOf(child.data) == -1) categoryIds.push(child.data);
      } else {
        this.TraverseChildNodes(child.children, categoryIds);
      }
    });
  }

  private LoadReportCategoryHierarchy() {
    this.loading =true;
    this.lookupService.getReportCategoryHierarchy$()
    .pipe(finalize(() => (this.loading = false)))
    .subscribe(data => {
      //console.log(Array.of(data));

      this.reportCategories = Array.of(data);
      this.reportCategories[0].expanded = true;
      this.reportCategories[0].children.sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });
    });
  }
  private LoadAllPosts() {
    this.lookupService.getAllPosts$().subscribe(postList => {
      this.posts.push({ label: 'All Posts', value: '' });
      postList.forEach(val => {
        if (
          this.posts
            .map(function(v) {
              return v.value;
            })
            .indexOf(val.locationName.toString()) == -1
        )
          this.posts.push({ label: val.locationName.toString(), value: val.locationName.toString() });
      });

      this.posts.sort((a, b) => {
        if (a.label === b.label) return 0;
        if (a.label == 'All Posts') return -1;
        if (b.label == 'All Posts') return 1;

        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });
    });

  
  }

  private LoadAllCountries() {
    this.lookupService.getAllCountries$().subscribe(countryList => {
      this.countries.push({ label: 'All Countries', value: '' ,styleClass:'ui-state-highlight'});
      countryList.forEach(val => {
        this.countries.push({ label: val.locationName.toString(), value: val.id });
      });
    });
    
    
    
  }

  private LoadBlockDateOptions() {
    this.blockDatesOptions = [
      { label: 'Select', value: '0' },
      { label: 'Today', value: '1' },
      { label: 'Most Recent Week', value: '7' },
      { label: 'Most Recent Month', value: '30' }
    ];
    this.blockDatesOptionsForInternal = [
      { label: 'Select', value: '0' },
      { label: 'Today', value: '1' },
      { label: 'Last 3 Days', value: '3' },
      { label: 'Most Recent Week', value: '7' },
      { label: 'Most Recent Month', value: '30' }
    ];
  }

  private onReset() {
    // history.pushState(null, null, window.location.href.split('#')[0]);
   //window.location.reload();
    this.keyword = '';
    this.selectedNodes = [];
    this.searchResults = new Array<SearchResult>();
    
    // (<HTMLInputElement>document.getElementById('rbBlockDate')).checked = true;
  }
  private ddlBlockDateOnClick(event:Event)
  {
      this.searchForm.patchValue({dateRange:'0',fromDate:'',toDate:''});
  }
  private calendarOnFocus(event:Event)
  {
    this.searchForm.patchValue({dateRange:'1',blockDate:'0'});
  }

}



// WEBPACK FOOTER //
// ./src/app/search/search.component.ts